import { render, staticRenderFns } from "./StatsAmbassades.vue?vue&type=template&id=9c2e2dc2&scoped=true&"
import script from "./StatsAmbassades.vue?vue&type=script&lang=js&"
export * from "./StatsAmbassades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2e2dc2",
  null
  
)

export default component.exports